import cx from "apps/website/utils/misc/cx";

import Icon from "../Icon/Icon";

import { StickerVariant, StickerSize, STICKER_SIZE_CLASSES } from "./types";

export interface IStickerProps {
  variant: StickerVariant;
  size?: StickerSize;
}

export default function Sticker({
  variant,
  size = "sm",
}: Readonly<IStickerProps>) {

  return (
    <div data-component={Sticker.name} className={cx("inline-block aspect-square", STICKER_SIZE_CLASSES[size])}>
      <Icon icon={variant} className="w-full h-full" />
    </div>
  );
}
